import { campoDeveSerMaiorQueZero, campoDeveSerMenorIgual, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type DadosPermuta = {
  permutaNoLocalFiscalCasas: string | number
  permutaNoLocalFiscalLotes: string | number
  permutaForaDoLocalFiscal: string | number
  porcetagemVgvPermutaFinanceiraBruta: string | number
  porcentagemDescontoPermutaFinanceira: string | number
  valorEscrituradoTerreno: string | number
  valido: boolean
}

export const dadosPermutaValorDefault = {
  permutaNoLocalFiscalCasas: '',
  permutaNoLocalFiscalLotes: '',
  permutaForaDoLocalFiscal: '',
  porcetagemVgvPermutaFinanceiraBruta: '',
  porcentagemDescontoPermutaFinanceira: '',
  valorEscrituradoTerreno: '',
  valido: true
} as DadosPermuta

export class ValidacaoDadosPermuta {
  permutaNoLocalFiscalCasas: string
  permutaNoLocalFiscalLotes: string
  permutaForaDoLocalFiscal: string
  porcetagemVgvPermutaFinanceiraBruta: string
  porcentagemDescontoPermutaFinanceira: string
  valorEscrituradoTerreno: string

  constructor(
    permutaNoLocalFiscalCasas = '',
    permutaNoLocalFiscalLotes = '',
    permutaForaDoLocalFiscal = '',
    porcetagemVgvPermutaFinanceiraBruta = '',
    porcentagemDescontoPermutaFinanceira = '',
    valorEscrituradoTerreno = ''
  ) {
    this.permutaNoLocalFiscalCasas = permutaNoLocalFiscalCasas
    this.permutaNoLocalFiscalLotes = permutaNoLocalFiscalLotes
    this.permutaForaDoLocalFiscal = permutaForaDoLocalFiscal
    this.porcetagemVgvPermutaFinanceiraBruta = porcetagemVgvPermutaFinanceiraBruta
    this.porcentagemDescontoPermutaFinanceira = porcentagemDescontoPermutaFinanceira
    this.valorEscrituradoTerreno = valorEscrituradoTerreno
  }

  validarInputUsuario(valor: string): string {
    let error = ''

    if (parseFloat(valor) === 0) error = campoDeveSerMaiorQueZero

    return error
  }

  validarInputPorcentagemUsuario(valor: string): string {
    let error = ''

    if (parseFloat(valor) === 0) error = campoDeveSerMaiorQueZero

    if (parseFloat(valor) > 100) error = `${campoDeveSerMenorIgual} 100.`

    return error
  }

  validarPermutaFinanceira(state: DadosPermuta): boolean {
    if (state.porcetagemVgvPermutaFinanceiraBruta != '' || state.porcentagemDescontoPermutaFinanceira != '' || state.valorEscrituradoTerreno != '') {
      return this.verificarValoresObrigatoriosPermutaFinanceira(state.porcetagemVgvPermutaFinanceiraBruta.toString(), state.valorEscrituradoTerreno.toString())
    }
    this.porcetagemVgvPermutaFinanceiraBruta = ''
    this.valorEscrituradoTerreno = ''
    return true
  }

  verificarValoresObrigatoriosPermutaFinanceira(porcetagemVgvPermutaFinanceiraBruta: string, valorEscrituradoTerreno: string): boolean {
    let isValido = true
    if (porcetagemVgvPermutaFinanceiraBruta == '') {
      this.porcetagemVgvPermutaFinanceiraBruta = campoObrigatorio
      isValido = false
    }
    if (valorEscrituradoTerreno == '') {
      this.valorEscrituradoTerreno = campoObrigatorio
      isValido = false
    }
    return isValido
  }
}
